import {get, isEmpty, lowerCase} from 'lodash';
import {createRequest} from './httpUtils';
import {USER_LOGOUT_API, USER_PROFILE_API, USER_PROFILE_UPDATE_API} from './constants';

export const logoutUser = (payload: any = {}) => {
  if (isEmpty(get(payload, 'user.userID'))) {
    return invalidLogout(payload);
  }
  console.log('Payload in logoutUser >>>', get(payload, 'user.userID'));
  return createRequest({
    api: USER_LOGOUT_API,
    body: {},
    token: payload.tokenData?.access_token,
    params: {
      userId: get(payload, 'user.userID', 'INVALID_USER'),
      role: lowerCase(get(payload, 'user.role')),
    },
  });
};

export const invalidLogout = (payload: any = {}) => {
  console.log('Payload in invalid >>> ', payload);
  return createRequest({
    api: USER_LOGOUT_API,
    body: {},
    token: payload?.tokenData?.access_token,
    params: {
      userId: 'invalid',
      role: lowerCase(get(payload, 'user.role')),
    },
  });
};

export const getUserProfileAPI = (payload: any = {}) => {
  return createRequest({
    api: USER_PROFILE_API,
    body: null,
    token: payload.tokenData?.access_token,
    params: {email: payload?.user?.email},
  });
};

export const updateUserProfileAPI = (payload: any = {}) => {
  return createRequest({
    api: USER_PROFILE_UPDATE_API,
    body: {...payload.user},
    token: payload.tokenData?.access_token,
    params: {userId: payload.user.id, role: lowerCase(payload?.user?.role)},
  });
};
